import React from 'react'

interface NotepadProps extends React.SVGProps<SVGSVGElement> {}
const Notepad: React.FC<NotepadProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='14'
      fill='none'
    >
      <path
        fill='#FFB800'
        d='M9.662 1.687A2.667 2.667 0 0 1 12 4.333V11a2.667 2.667 0 0 1-2.667 2.667H2.667A2.667 2.667 0 0 1 0 11V4.333a2.667 2.667 0 0 1 2.338-2.646A2.167 2.167 0 0 0 4.5 4h3a2.167 2.167 0 0 0 2.162-2.313ZM3.333 10.5a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H3.333Zm0-2.666a.5.5 0 0 0 0 1h5.334a.5.5 0 0 0 0-1H3.333Zm0-2.667a.5.5 0 0 0 0 1h5.334a.5.5 0 0 0 0-1H3.333Zm4-4.834a1.334 1.334 0 0 1 0 2.667H4.667a1.334 1.334 0 1 1 0-2.667h2.666Z'
      />
    </svg>
  )
}

export default Notepad
